// SEO Constants for OFFR Application

export const DEFAULT_SEO = {
  title: "O'zbekistondagi eng yaxshi chegirmalar va aksiyalar | OFFR",
  description: "Toshkent va O'zbekiston bo'ylab eng so'nggi chegirmalar, aksiyalar va promokodlar. Offr.uz bilan doimo foydali xaridlar qiling va mablag'ingizni tejang!",
  keywords: 'chegirmalar, aksiyalar, promokodlar, Toshkent, arzon narxlar, xarid qilish, tejash, kuponlar',
  image: '/logo512.png',
  url: 'https://offr.uz',
  siteName: 'OFFR',
  twitterHandle: '@offr_deals',
};

export const PAGE_SEO = {
  home: {
    title: 'Eng yaxshi chegirmalar va takliflar',
    description:
      'Top brendlar va mahalliy bizneslardan ajoyib takliflar, chegirmalar va reklama aksiyalarini toping. Eksklyuziv chegirmalar va promokodlar bilan pul tejang.',
    keywords: 'takliflar, chegirmalar, aksiyalar, tejash, xarid qilish',
  },
  categories: {
    title: 'Kategoriyalar — takliflar va chegirmalar',
    description:
      "Takliflarni kategoriya bo'yicha ko'rib chiqing. Oziq-ovqat, ko'ngilochar, avtomobil, go'zallik, salomatlik, ta'lim va boshqa sohalarda takliflarni toping.",
    keywords:
      "kategoriyalar, kategoriya bo'yicha takliflar, oziq-ovqat takliflari, ko'ngilochar takliflar, avtomobil chegirmalari",
  },
  offers: {
    title: 'Takliflar va chegirmalar',
    description: "Barcha mavjud takliflar va chegirmalarni ko'rib chiqing. Eng yaxshi aksiyalar va chegirmalarni toping.",
    keywords: 'barcha takliflar, chegirmalar, aksiyalar, maxsus takliflar',
  },
  promocodes: {
    title: 'Promokodlar va chegirma kuponlari',
    description:
      'Sevimli brendlaringiz va xizmatlaringiz uchun eksklyuziv promokodlar va chegirma kuponlarini oling.',
    keywords: 'promokodlar, chegirma kodlari, kuponlar, vaucherlar, maxsus kodlar',
  },
  favorites: {
    title: 'Saqlangan takliflar',
    description: "Saqlangan takliflar va chegirmalaringizni ko'ring. Sevimli aksiyalaringizni kuzatib boring.",
    keywords: 'saqlangan takliflar, sevimli takliflar, belgilangan aksiyalar',
  },
  profile: {
    title: 'Profil',
    description: 'Profilingiz, sozlamalaringiz va saqlangan takliflaringizni boshqaring.',
    keywords: 'foydalanuvchi profili, hisob sozlamalari, sozlamalar',
  },
};

export const CATEGORY_SEO = {
  food: {
    title: 'Oziq-ovqat takliflari va restoran chegirmalari',
    description:
      "Eng yaxshi oziq-ovqat takliflari, restoran chegirmalari va ovqatlanish aksiyalarini toping. Sevimli taomlaringizda tejang va yangi taomlarni sinab ko'ring.",
    keywords: 'oziq-ovqat takliflari, restoran chegirmalari, ovqatlanish aksiyalari, taom promolari',
  },
  entertainment: {
    title: "Ko'ngilochar takliflar va tadbirlar",
    description:
      "Ko'ngilochar takliflar, tadbir chiptalar, kino chegirmalari va qiziqarli faoliyat aksiyalarini kashf eting.",
    keywords: "ko'ngilochar takliflar, tadbir aksiyalari, kino chegirmalari, faoliyat promolari",
  },
  automotive: {
    title: 'Avtomobil takliflari va servis xizmatlari',
    description: "Avtomobil takliflari, servis xizmatlari va transport texnik xizmat ko'rsatish chegirmalarini oling.",
    keywords: 'avtomobil takliflari, servis xizmatlari, transport chegirmalari, avto promolari',
  },
  'beauty-salons': {
    title: "Go'zallik salonlari va spa takliflari",
    description: "Go'zallik salonlari takliflari, spa aksiyalari va shaxsiy parvarish xizmatlari chegirmalarini toping.",
    keywords: "go'zallik saloni takliflari, spa aksiyalari, go'zallik chegirmalari, shaxsiy parvarish promolari",
  },
  'clothing-and-footwear': {
    title: 'Moda takliflari va kiyim-kechak aksiyalari',
    description: 'Top brendlardan moda takliflari, kiyim-kechak va poyabzal chegirmalarini xarid qiling.',
    keywords: 'moda takliflari, kiyim-kechak aksiyalari, poyabzal chegirmalari, kiyim promolari',
  },
  dentistry: {
    title: 'Stomatologiya takliflari va tish parvarishi',
    description: "Stomatologiya takliflari, tish parvarishi xizmatlari va og'iz bo'shlig'i salomatligi chegirmalarini toping.",
    keywords: "stomatologiya takliflari, tish parvarishi, og'iz salomatligi chegirmalari, dental promolar",
  },
  education: {
    title: "Ta'lim takliflari va kurs aksiyalari",
    description: "Ta'lim takliflari, kurs aksiyalari va o'quv xizmatlari chegirmalarini kashf eting.",
    keywords: "ta'lim takliflari, kurs aksiyalari, o'quv chegirmalari, ta'lim promolari",
  },
  flowers: {
    title: "Gul takliflari va gul do'koni aksiyalari",
    description: "Gul takliflari, gul kompozitsiyalari va bog' xizmatlari aksiyalarini toping.",
    keywords: "gul takliflari, gul aksiyalari, bog' chegirmalari, gul yetkazib berish promolari",
  },
  'health-and-sport': {
    title: 'Salomatlik va fitness takliflari',
    description: "Salomatlik va fitness takliflari, sport zal aksiyalari va salomatlik xizmatlari chegirmalarini oling.",
    keywords: 'salomatlik takliflari, fitness aksiyalari, sport zal chegirmalari, salomatlik promolari',
  },
  hotels: {
    title: 'Mehmonxona takliflari va turar joy aksiyalari',
    description: 'Mehmonxona takliflari, turar joy aksiyalari va sayohat turar joy chegirmalarini toping.',
    keywords: 'mehmonxona takliflari, turar joy aksiyalari, turar joy chegirmalari, sayohat promolari',
  },
  'medical-centers': {
    title: "Tibbiyot markazlari va sog'liqni saqlash takliflari",
    description: "Tibbiyot markazlari takliflari, sog'liqni saqlash aksiyalari va tibbiy xizmatlar chegirmalarini kashf eting.",
    keywords: "tibbiy takliflar, sog'liqni saqlash aksiyalari, tibbiyot markazi chegirmalari, salomatlik promolari",
  },
  miscellaneous: {
    title: 'Turli xil takliflar va aksiyalar',
    description: "Turli kategoriyalardan turli xil takliflar va aksiyalarni o'rganing.",
    keywords: 'turli xil takliflar, har xil aksiyalar, umumiy chegirmalar, aralash promolar',
  },
  'printing-centers': {
    title: 'Chop etish takliflari va hujjat xizmatlari',
    description: 'Chop etish takliflari, hujjat xizmatlari aksiyalari va ofis xizmatlari chegirmalarini toping.',
    keywords: 'chop etish takliflari, hujjat xizmatlari, ofis chegirmalari, chop etish promolari',
  },
  'real-estate': {
    title: "Ko'chmas mulk takliflari va mulk aksiyalari",
    description: "Ko'chmas mulk takliflari, mulk aksiyalari va uy-joy xizmatlari chegirmalarini kashf eting.",
    keywords: "ko'chmas mulk takliflari, mulk aksiyalari, uy-joy chegirmalari, ko'chmas mulk promolari",
  },
  tourism: {
    title: 'Turizm takliflari va sayohat aksiyalari',
    description: "Turizm takliflari, sayohat aksiyalari va ta'til paketlari chegirmalarini toping.",
    keywords: "turizm takliflari, sayohat aksiyalari, ta'til chegirmalari, turizm promolari",
  },
};

export const PAGE_SEO_RU = {
  home: {
    title: 'Лучшие скидки и предложения',
    description:
      'Находите лучшие предложения, скидки и акции от топ-брендов и местного бизнеса. Экономьте с эксклюзивными скидками и промокодами.',
    keywords: 'предложения, скидки, акции, экономия, покупки',
  },
  categories: {
    title: 'Категории — предложения и скидки',
    description:
      'Просматривайте предложения по категориям. Находите акции в сфере еды, развлечений, авто, красоты, здоровья, образования и других.',
    keywords: 'категории, предложения по категориям, скидки на еду, развлечения, автомобильные скидки',
  },
  offers: {
    title: 'Предложения и скидки',
    description: 'Просматривайте все доступные предложения и скидки. Находите лучшие акции.',
    keywords: 'все предложения, скидки, акции, специальные предложения',
  },
  promocodes: {
    title: 'Промокоды и купоны на скидки',
    description:
      'Получайте эксклюзивные промокоды и купоны на скидки для ваших любимых брендов и услуг.',
    keywords: 'промокоды, коды на скидки, купоны, ваучеры, специальные коды',
  },
  favorites: {
    title: 'Сохранённые предложения',
    description: 'Просматривайте сохранённые предложения и скидки. Следите за любимыми акциями.',
    keywords: 'сохранённые предложения, избранные, отмеченные акции',
  },
  profile: {
    title: 'Профиль',
    description: 'Управляйте своим профилем, настройками и сохранёнными предложениями.',
    keywords: 'профиль пользователя, настройки аккаунта, настройки',
  },
};

export const getLocalizedPageSEO = (page, locale) => {
  if (locale === 'ru') return PAGE_SEO_RU[page] || PAGE_SEO[page];
  return PAGE_SEO[page];
};

export const STRUCTURED_DATA = {
  organization: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'OFFR',
    description: "O'zbekistondagi eng yaxshi chegirmalar va takliflar platformasi",
    url: 'https://offr.uz',
    logo: 'https://offr.uz/logo512.png',
    sameAs: [
      'https://www.instagram.com/offr.uz',
      'https://t.me/offr_uz',
    ],
  },
  website: {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'OFFR',
    url: 'https://offr.uz',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://offr.uz/uz/categories?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  localBusiness: {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'OFFR',
    url: 'https://offr.uz',
    logo: 'https://offr.uz/logo512.png',
    telephone: '+998936137933',
    email: 'bekmansur83@gmail.com',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'UZ',
      addressLocality: 'Toshkent',
    },
  },
};
